import { render } from "./AssetEvaluation.vue?vue&type=template&id=6b04b8c8&scoped=true"
import script from "./AssetEvaluation.vue?vue&type=script&lang=js"
export * from "./AssetEvaluation.vue?vue&type=script&lang=js"

import "./AssetEvaluation.vue?vue&type=style&index=0&id=6b04b8c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b04b8c8"]])

export default __exports__